module.exports = __webpack_public_path__ + "img/BRCA3_NK.a35d61ec.png";